import React, { useEffect, useState } from 'react';
import { 
  LayoutDashboard, 
  Users, 
  Settings, 
  FileText, 
  Bell, 
  LogOut,
  ChevronLeft,
  Menu,
  X
} from 'lucide-react';
import '../../../styles/Sidebar.css';

const Sidebar = ({ 
  isOpen, 
  onToggle, 
  currentView, 
  onViewChange, 
  onLogout 
}) => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    if (isMobile && isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isMobile, isOpen]);

  const menuItems = [
    { id: 'dashboard', label: 'Cuadro de mandos', icon: LayoutDashboard },
    //{ id: 'users', label: 'Usuarios', icon: Users },
    //{ id: 'documents', label: 'Documentos', icon: FileText },
    //{ id: 'notifications', label: 'Notificaciones', icon: Bell },
    { id: 'settings', label: 'Configuración', icon: Settings },
  ];

  const handleItemClick = (id) => {
    onViewChange(id);
    if (isMobile) onToggle();
  };

  // Determinar clases dinámicas
  const getSidebarClasses = () => {
    const baseClass = 'sidebar';
    if (isMobile) {
      return `${baseClass} ${isOpen ? 'mobile-open' : 'mobile-closed'}`;
    }
    return `${baseClass} ${isOpen ? 'desktop-open' : 'desktop-closed'}`;
  };

  const getHeaderClasses = () => {
    if (isMobile && isOpen) return 'sidebar-header mobile-open open';
    if (isOpen) return 'sidebar-header open';
    return 'sidebar-header closed';
  };

  return (
    <>
      {isOpen && (
        <div 
          className={`sidebar-overlay ${isOpen ? 'open' : ''}`} 
          onClick={onToggle} 
        />
      )}
      
      <aside className={getSidebarClasses()}>
        <div className={getHeaderClasses()}>
          <div className={`logo-container ${isOpen ? 'open' : 'closed'}`}>
            {isOpen && (
              <div className="logo-wrapper-side">
                <img src="/img/base_logo.png" alt="Logo" className="logo-img" />
                <h1 className="logo">Mi Farmacia</h1>
              </div>
            )}
          </div>
          
          <button onClick={onToggle} className="toggle-btn">
            <div className={`toggle-icon ${isOpen ? 'open' : 'closed'}`}>
              {isMobile && isOpen ? <X size={20} /> : <ChevronLeft size={20} />}
            </div>
          </button>
        </div>

        <nav className="sidebar-nav">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = currentView === item.id;
            
            return (
              <button
                key={item.id}
                onClick={() => handleItemClick(item.id)}
                className={`nav-item ${isActive ? 'active' : ''} ${isOpen ? 'open' : 'closed'}`}
              >
                <div className="nav-icon">
                  <Icon size={22} />
                </div>
                <span className={`nav-label ${isOpen ? 'open' : 'closed'}`}>
                  {item.label}
                </span>
              </button>
            );
          })}
        </nav>

        <div className="sidebar-footer">
          <button
            onClick={onLogout}
            className={`logout-btn ${isOpen ? 'open' : 'closed'}`}
          >
            <div className="nav-icon">
              <LogOut size={22} />
            </div>
            <span className={`nav-label ${isOpen ? 'open' : 'closed'}`}>
              Cerrar Sesión
            </span>
          </button>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;